(function($, undefined) {
	
	'use strict';
	var annexList;
	var annexForm;
	var formValidator;
	var popupUtil;
	var editTitleBtn;
	var editTitlePopup;
	var saveTitleBtn;
	var currId;
	var currPage;
	
	var annexFileInput;

	var addAnnexForm = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		
		if (!form.hasClass('has-error')) {
			var id = $('[name=id]', form).length > 0 ? $('[name=id]', form).val() : null;
			var title = 'Nouvelle section';
			var annexText = null;
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'annex',
				field2: title,
				field4: annexText,
				field5: ''
			};
			if (id) {
				params.id = id;
			}
			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					if (response.responseText.indexOf('success') !== -1) {
						location.reload();
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};
	
	var submitAnnexForm = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		
		if (!form.hasClass('has-error')) {
			var id = $('[name=id]', form).length > 0 ? $('[name=id]', form).val() : null;
			var annexTextarea = $('[name=field4]', form);
			var annexText = annexTextarea.length > 0 ? tinymce.get(annexTextarea.attr('id')).getContent() : null;
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'annex',
				field4: annexText,
				field5: populateListFromSection(form),
			};
			if (id) {
				params.id = id;
			}
			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					if (response.responseText.indexOf('success') !== -1) {
						location.reload();
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};

	var delAnnexItem = function () {
		var t = $(this);
		var item = t.closest('.annex-file-list-item');
		var id = item.attr('data-id');
		var name = item.attr('data-name');

		item.remove();
		$('.post-form-gallery-edit-item[data-media-id="'+id+'"]').remove();
	};

	var populateListFromSection = function(form) {
		return form.find('.annex-file-list-item:not(.clone)').map((i, el) => {
			const {name, id} = el.dataset;
			return `${id}*${name}`;
		}).get().join();
	};

	var annexFileUpload = function() {
		var t = $(this);
		var bigCtn = t.closest('.annex-edit-form');
		var annexList = $('.annex-file-list', bigCtn);
		var errorMessage = $('.annex-file-input-error', bigCtn);
		var files = t[0].files;
		var callbackCount = 0;
		var currTime = new Date().getTime();
		
		if (files !== undefined) {
			for (var i = 0;i<files.length;i++) {
				
				var re = /(?:\.([^.]+))?$/;
				var ext = re.exec(files[i].name)[1];
				
				//if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif') {
					var newElt = $('.annex-file-list-item.clone', annexList).eq(0).clone().removeClass('clone');
					var newEltNameCtn = $('.annex-file-list-item-name', newElt);
					newEltNameCtn.text(files[i].name);
					newElt.addClass('processing');
					newElt.attr('data-id-upload', String(currTime)+'-'+String(i));
					newElt.attr('data-ext', ext);
					newElt.attr('data-name', files[i].name);
				
					annexList.append(newElt);
					$('.annex-file-list-item-action-btn.close', newElt).click(delAnnexItem);
					
					var data = new FormData();
					data.append('image', files[i]);
					data.append('directory', 'Annexes');
					data.append('ajax', 'true');
					data.append('noCrop', 'true');
					data.append('customLabel', 'annexes');
		               
					$.ajax({
						url: '/action/uploadCroppedImage',
						cache: false,
						contentType: false,
						processData: false,
						method: 'POST',
						data: data,
						success: function (data) {
							var currElt = $('.annex-file-list-item[data-id-upload="'+currTime+'-'+callbackCount+'"]');
							var id = data.substr('success?mediaId='.length);
							var name = currElt.attr('data-name');
							var currExt = currElt.attr('data-ext');
							currElt.attr('data-id', (id).replace(/(\r\n\t|\n|\r\t)/gm,""));
							currElt.removeClass('processing');
							callbackCount++;
						}
					});
				/*} else {
					errorMessage.slideDown(200, function () {
						setTimeout(function () {
							errorMessage.slideUp(200);
						}, 5000);
					});
				}*/
			}
		}
	};

	var openEditTitlePopup = function(e) {
		e.stopPropagation();
		var btn = $(this);
		var label = btn.attr('data-title');
		var currentValue = btn.attr('data-title-value');
		currId = $(this).closest('.admin-box-ctn').attr('data-id');
		
		editTitlePopup.find('input[name=value]').val(currentValue);
		editTitlePopup.find('input[name=label]').val(label);
		popupUtil.openPopupById(editTitlePopup.attr('id'));
	};
	
	var saveTitle = function() {
		var popup = $(this).closest('.popup-outer');
		popup.find('.has-processing').addClass('processing');
		var newValue = popup.find('input[name=value]').val();
		var label = popup.find('input[name=label]').val();
		
		var action = "/action/manageGenData";
		var params = {
			ajax: true,
			field1: 'annex',
			field2: newValue
		};
		if (currId) {
			params.id = currId;
		}
		$.ajax({
			url: action,
			method: "post",
			data: params,
			complete: function(response) {
				console.log(response.responseText);
				console.log(params);
				if (response.responseText.indexOf('success') !== -1) {
					location.reload();
				} else {
					form.removeClass('processing');
				}
			}
		});
	};
	
	var init = function (page) {
		currPage = $(page);
		popupUtil = Fw.component.models().popup;
		formValidator = Fw.component.models().form;
		annexList = $('.annex-admin-form');
		annexForm = $('.annex-edit-form');
		editTitleBtn = $('.edit-annex-title-btn');
		editTitlePopup = $('#edit-annex-title-popup');
		saveTitleBtn = $('.save-annex-title-btn');

		annexFileInput = $('.form-item-upload-input[name=annex-file-upload]');
		
		$('.add-annex-btn', annexList).on('click', addAnnexForm);
		$('.save-annex-btn', annexForm).on('click', submitAnnexForm);
		$('.annex-file-list-item-action-btn.delete').click(delAnnexItem);
		editTitleBtn.on('click', openEditTitlePopup);
		annexFileInput.change(annexFileUpload);
		saveTitleBtn.on('click', saveTitle);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
